import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useLogout } from '../../features/auth/useSession';

const NAV = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/accounts', label: 'Accounts', end: false },
  { to: '/admin/integrations', label: 'Integrations', end: false },
];

/** Shell for the platform admin area — its own chrome, separate from the app. */
export function AdminLayout() {
  const logout = useLogout();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-full flex-col bg-neutral-50">
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 sm:px-6">
          <div className="flex items-center gap-2">
            <span className="font-semibold tracking-tight text-neutral-900">KatSquare Draft</span>
            <span className="rounded bg-neutral-900 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
              Admin
            </span>
          </div>
          <nav className="flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `rounded-md px-3 py-1.5 text-sm font-medium ${
                    isActive ? 'bg-neutral-100 text-neutral-900' : 'text-neutral-500 hover:text-neutral-900'
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button
            type="button"
            onClick={() => logout().then(() => navigate('/admin/login'))}
            className="ml-auto text-sm text-neutral-500 hover:text-neutral-900"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
